// /* eslint-disable */
import React, { useState } from "react";
import { Modal, Button, Upload, Typography, message } from "antd";
import {
  UploadOutlined,
  CheckCircleFilled,
  FileTextOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import warningIcon from "@/assets/images/icons/warning_2.png";
import rowsIcon from "@/assets/images/icons/rows.png";
const { Text } = Typography;

const UploadTransactionsModal = ({ open, onCancel, onSuccess }) => {
  const [csvUploading, setCsvUploading] = useState(false);
  const [checkModalVisible, setCheckModalVisible] = useState(false);
  const [checkResult, setCheckResult] = useState(null);
  const [checkMsg, setCheckMsg] = useState("");

  const reset = () => {
    setCheckResult(null);
    setCheckMsg("");
    setCheckModalVisible(false);
  };

  const handleClose = () => {
    onCancel?.();
    reset();
  };

const handleDownloadInstruction = () => {
  const link = document.createElement("a");
  link.href = "/files/Deposit-Check-Cash-Upload-Instruction.docx";
  link.download = "Deposit-Check-Cash-Upload-Instruction.docx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  // 校验接口
const beforeUpload = async (file) => {
  const isCsv = /\.csv$/i.test(file?.name || "");
  if (!isCsv) {
    message.error("Please upload a CSV file (.csv).");
    return Upload.LIST_IGNORE;
  }

  const formData = new FormData();
  formData.append("file", file);
  try {
    setCsvUploading(true);
    const res = await http.post(api.getDepositCheckUpload, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (res?.code === "1") {
      setCheckResult({ ...res?.data, msg: res?.msg });
      setCheckMsg("");
    } else {
      setCheckResult(null);
      setCheckMsg(res?.msg || "Upload failed");
    }
    setCheckModalVisible(true);
  } catch (e) {
    message.error("Upload failed");
    setCheckModalVisible(false);
  } finally {
    setCsvUploading(false);
  }

  return false;
};
const handleCloseResult = () => {
  const isSuccess = !!checkResult;
  setCheckModalVisible(false);
  setCheckResult(null);
  setCheckMsg("");
  if (isSuccess) {
    onSuccess?.();
  }
};
const renderCheckResult = () => {
  // 失败
  if (!checkResult && checkMsg) {
    return (
      <div className="check-result">
        <div className="policy-box error-box">
          <div className="policy-alert error">
            <img src={warningIcon} alt="icon" />
            <div
              className="error-msg"
              style={{ wordBreak: "break-word", whiteSpace: "normal" }}
            >
              {checkMsg}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!checkResult) return null;

  // 成功
  return (
    <div className="check-result">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "12px 14px",
          marginBottom: 20,
          background: "#f6ffed",
          border: "1px solid #b7eb8f",
          borderRadius: 6,
        }}
      >
        <CheckCircleFilled style={{ color: "#52c41a", fontSize: 20 }} />
        <div>
          <div style={{ color: "#52c41a", fontWeight: 600 }}>Success</div>
          <div style={{ color: "#595959", fontSize: 13, marginTop: 2 }}>
            {checkResult.msg}
          </div>
        </div>
      </div>

      <div className="summary">
        <div className="summary-title">Summary</div>
        <div className="summary-cards">
          <div className="card">
            <div className="card-icon purple">
              <FileTextOutlined style={{ fontSize: 20 }} />
            </div>
            <div className="card-content">
              <div className="card-label">Batch #</div>
              <div className="card-value">{checkResult.batch ?? "-"}</div>
            </div>
          </div>

          <div className="card">
            <div className="card-icon">
              <img src={rowsIcon} alt="rows" />
            </div>
            <div className="card-content">
              <div className="card-label">Total Rows</div>
              <div className="card-value">{checkResult.count ?? 0}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

  return (
    <>
<Modal
  open={open}
  width="60%"
  centered
  destroyOnClose
  maskClosable={false}
  onCancel={handleClose}
  afterClose={reset}
  footer={
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Button onClick={handleClose}>Close</Button>
    </div>
  }
  title={null}
>
        <div
          style={{
            height: "65vh",
            minHeight: 520,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ padding: "14px 16px" }}>
            <div
              style={{
                width: "52%",
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <UploadOutlined style={{ color: "#e55353", fontSize: 18 }} />
             <Text style={{ color: "#e55353", fontWeight: 700, fontSize: 18 }}>
               DEPOSIT CHECK/CASH UPLOAD</Text>
            </div>
            <div className="model_top"></div>
          </div>

          <div style={{ flex: 1, display: "flex" }}>
  <div style={{ width: "50%" }}>
  <div style={{ padding: 24, height: "100%" }}>
    <Upload
      accept=".csv"
      showUploadList={false}
      beforeUpload={beforeUpload}
      disabled={csvUploading}
    >
      <Button className="btnNew" loading={csvUploading}>
        <UploadOutlined />
        Upload
      </Button>
    </Upload>
  </div>
</div>

            <div style={{ width: "50%" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <InfoCircleOutlined style={{ color: "#1677ff", fontSize: 18 }} />
                <Text style={{ fontWeight: 600, fontSize: 16, color: "#666" }}>
                  Information Detail
                </Text>
              </div>

              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 36px",
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <div style={{ fontSize: 24, color: "#8c8c8c", lineHeight: 1.3 }}>
                  <br />
                 To Use Deposit Check/Cash Upload, Please Drag & Drop a CSV File
                   
                  </div>
                  <div
                    style={{
                      marginTop: 24,
                      fontSize: 18,
                      color: "#8c8c8c",
                      lineHeight: 1.6,
                    }}
                  >  Deposit Check/Cash Upload function allows users to record single and multiple Invoices.
                   <br />
                    For the CSV file formatting instructions, please click link below.
                     <br />
                     Please Note: This process can take up to 10 minutes.
                    <br /> 
                    The max invoice allowed to be post at once time is only 100.
                  </div>

                  <div style={{ marginTop: 34 }}>
                    <Button
                      type="primary"
                      size="large"
                      icon={<FileTextOutlined />}
                      onClick={handleDownloadInstruction}
                      style={{
                        height: 56,
                        padding: "0 28px",
                        fontSize: 18,
                        textDecoration: "underline",
                      }}
                    >
                     Click Here for File Format Instruction
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* 校验结果弹窗 */}
 <Modal
  title="CSV Upload Result"
  open={checkModalVisible}
  onCancel={handleCloseResult}
  maskClosable={false}
  width={600}
  zIndex={2000}
  centered
  footer={
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Button type="primary" onClick={handleCloseResult}>
        Close
      </Button>
    </div>
  }
>
  {renderCheckResult()}
</Modal>
    </>
  );
};

export default UploadTransactionsModal;